import React from 'react'

export default function DownArrowIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={20} viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-2 h-2 float-end">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  )
}
